import referenceDate from "../chronology/reference-date";

export default function findDayByDate(
  date, // May be `null` for current date.
  parentSeasonContentForSchoolLevel,
  { getters },
) {
  if (!getters.containerLoaded) {
    return null;
  }

  // Return the day record (if any) matching the given or current date.

  // Create a new `Date` object avoid side effect.
  const reference = referenceDate(date);

  return parentSeasonContentForSchoolLevel.days.reduce((acc, cur) => {
    // First one found is the one we want.
    if (acc) {
      return acc;
    }

    // Match the one (if any) which the current date falls into.
    if (new Date(cur.date).getTime() === reference.getTime()) {
      return cur;
    }

    // Carry either null or the matched item
    // if conditions do not apply.
    // -> Replace acc (null) with cur when the condition matches
    //    and do not change acc after the first assignment.
    return acc;
  }, null);
}
